/* eslint-disable*/
/* global d3 $ _ */
/* eslint-disable-line */
//import "../../assets/lasso.css";
//import '../../vendor/chernoff.js';
import { remove_duplicate_elements } from '../../helper/helper';
import { getCorrectnessColor, getRelationColor } from '../../vendor/color_helper';
import DrawScatterPlot from './drawScatterPlot'
import DrawRelationList from './drawRelationList';
import pipeService from '../../service/pipeService';
let DrawMainView = function(id_dict, update_color_items) {
    this.id = id_dict["mainView"];
    this.divWidth = $('#' + this.id).width()
    this.divHeight = $('#' + this.id).height()
    this.margin = { top: 0, right: 0, bottom: 0, left: 0 }
    this.width = this.divWidth - this.margin.left - this.margin.right
    this.height = this.divHeight - this.margin.top - this.margin.bottom

    this.id_dict = id_dict;
    this.qs_id = id_dict["qs"];
    this.tc_id = id_dict["tc"];
    this.relation_id = id_dict["relation"];

    this.update_color_items = update_color_items;

    // mainView settings
    var qs_scatter_plot = new DrawScatterPlot(this.qs_id);
    var tc_scatter_plot = new DrawScatterPlot(this.tc_id);
    var relation_plot = new DrawRelationList(this.relation_id);

    this.plot_config = {
        "qs_plot": qs_scatter_plot,
        "tc_plot": tc_scatter_plot,
        "relation_plot": relation_plot
    }
}

function judge_selected_by_relation(item, selected_relation=[]){
    if(selected_relation.length == 0){
        return true;
    }else{
        let question_concept_correct_answer_relations = item.question_concept_correct_answer_relations;
        let relations_list = question_concept_correct_answer_relations.map((d)=>d[0]);
        let unique_relation_list = remove_duplicate_elements(relations_list);
        let selected_by_relation = false;
        unique_relation_list.forEach(d=>{
            if(selected_relation.indexOf(d)>=0){
                selected_by_relation = true;
            }
        })
        return selected_by_relation;
    }
}
function process_relation_info(data, topk=-1, selected_relation=[]) {
    // Required Keys: "is_correct", "question_concept_correct_answer_relations"

    // Stage 1:
    // Output: {relation: {
    //     "freq": total freq,
    //     "correct_num": correct freq
    // }}
    var relation_freq_dict = {};
    for(let i = 0; i<data.length; i++){
        let d = data[i];
        let is_correct = d.is_correct;
        let question_concept_correct_answer_relations = d.question_concept_correct_answer_relations;
        let relations_list = question_concept_correct_answer_relations.map((d)=>d[0]);
        let unique_relation_list = remove_duplicate_elements(relations_list);
        unique_relation_list.forEach(d=>{
            if(!relation_freq_dict.hasOwnProperty(d)){
                relation_freq_dict[d] = {
                    "freq": 0,
                    "correct_num": 0
                }
            }
            relation_freq_dict[d]["freq"] += 1;
            if(is_correct){
                relation_freq_dict[d]["correct_num"] += 1;
            }
        })
    }

    // Stage 2: 
    // Find the topk freq relations.

    var relation_info_list = [];
    Object.keys(relation_freq_dict).forEach(d=>{
        let acc = 0;
        if(relation_freq_dict[d]["freq"] > 0){
            acc = relation_freq_dict[d]["correct_num"] / relation_freq_dict[d]["freq"];
        }
        relation_info_list.push({
            "relation_name": d,
            "freq": relation_freq_dict[d]["freq"],
            "correct_num": relation_freq_dict[d]["correct_num"],
            "acc": acc
        })
    })
    relation_info_list.sort((a,b)=>{
        return b.freq - a.freq;
    })
    var relation_mapping_to_index = {};
    relation_info_list.forEach((d,index)=>{
        relation_mapping_to_index[d.relation_name] = index;
    })
    var sliced_relation_info_list = [];
    if(relation_info_list.length>topk && topk>0){
        sliced_relation_info_list = relation_info_list.slice(0, topk);
    }else{
        sliced_relation_info_list = relation_info_list;
    }
    for(let i = 0; i<sliced_relation_info_list.length; i++){
        let relation_name = sliced_relation_info_list[i]["relation_name"];
        if(selected_relation.indexOf(relation_name)>=0){
            sliced_relation_info_list[i]["selected"] = true;
        }else{
            sliced_relation_info_list[i]["selected"] = false;
        }
    }
    return {
        "relation_info_list": sliced_relation_info_list, 
        "relation_mapping_to_index": relation_mapping_to_index
    }

}

function construct_index_mapping(mainkeys, selectedkeys){
    let mapping = {};
    if(selectedkeys.length>0){
        mainkeys.forEach((d)=>{
            mapping[d] = false;
        })
        selectedkeys.forEach((d)=>{
            mapping[d] = true;
        })
    }else{
        mainkeys.forEach((d)=>{
            mapping[d] = true;
        })
    }
    return mapping;
}

function compareTwoListofItems(a, b){
    if(a.length !== b.length){
        return false;
    }
    for(let i = 0 ; i<a.length; i++){
        if(a.index !== b.index){
            return false;
        }
    }
    return true;
}

function getItemColor(item, color_mode, relation_mapping_to_index, selected_relation){
    // color_mode: 1 , color by relation
    // color_mode: 2 , color by correctness
    let correctness = item["is_correct"];
    let question_concept_correct_answer_relations = item.question_concept_correct_answer_relations;
    let relations_list = question_concept_correct_answer_relations.map((d)=>d[0]);
    let relation_index = relation_mapping_to_index[relations_list[0]];

    if(selected_relation.length>0){
        relation_index = relation_mapping_to_index[selected_relation[0]];
    }
    if(color_mode == 1){
        
        return getRelationColor(relation_index);
    }else if(color_mode == 2){
        return getCorrectnessColor(correctness);
    }
}

function getColorItems(color_mode, relation_mapping_to_index){
    // color_mode: 1 , color by relation
    // color_mode: 2 , color by correctness
    let color_items = [];
    let correctness_keys = [false, true]
    if(color_mode == 1){
        Object.keys(relation_mapping_to_index).forEach(d=>{
            color_items.push({
                "color": getRelationColor(relation_mapping_to_index[d]),
                "label": d
            })
        })
    }else if(color_mode == 2){
        correctness_keys.forEach(d=>{
            color_items.push({
                "color": getCorrectnessColor(d),
                "label": ""+d
            })
        })
    }
    return color_items
}

function getCoordinatesbyProjectionMode(concept_type, projection_mode, items){
    // Concept Type: qs, tc
    // Projection Mode: 
    //     1-->Original
    //     2-->Relation 
    //     3-->Correctness 
    //     4-->Original x Transformed
    //     5-->Relation x Transformed
    //     6-->Correctness x Transformed   
    if(concept_type == "qs"){
        let prefix = "qs_";
        if(projection_mode == 1){
            prefix += "2d_";
        }else if(projection_mode == 2){
            prefix += "rel_2d_";
        }else if(projection_mode == 3){
            prefix += "acc_2d_";
        }else if(projection_mode == 4){
            prefix += "2d_trans_";
        }else if(projection_mode == 5){
            prefix += "2d_rel_trans_";
        }else if(projection_mode == 6){
            prefix += "2d_acc_trans_";
        }
        let x_field = prefix + "x";
        let y_field = prefix + "y";
        return {
            "x": items[x_field],
            "y": items[y_field]
        }
    }else if(concept_type == "tc"){
        let prefix = "tc_";
        if(projection_mode == 1 || projection_mode == 4){
            prefix += "2d_";
        }else if(projection_mode == 2 || projection_mode == 5){
            prefix += "rel_2d_";
        }else if(projection_mode == 3 || projection_mode == 6){
            prefix += "acc_2d_";
        }
        let x_field = prefix + "x";
        let y_field = prefix + "y";
        return {
            "x": items[x_field],
            "y": items[y_field]
        }
    }
    

}

function replace_relations_as_others(data, other_relations = []){
    let new_data = structuredClone(data);
    let other_relations_set = new Set(other_relations);
    for(let i = 0; i<new_data.length; i++){
        let item = new_data[i];
        let rel_list = item.question_concept_correct_answer_relations;
        let new_rel_list = rel_list.map(d=>{
            if(other_relations_set.has(d[0])){
                return ['others', d[1]];
            }else{
                return d;
            }
        })
        new_data[i].question_concept_correct_answer_relations = new_rel_list;

    }
    return new_data;
}
function getInfo(d){
    return {
        "question_concept": d.question_concept,
        "question_stem": d.raw_question.question.stem,
        "target_concept": d.ground_truth
    }
}

DrawMainView.prototype.reset_scale = function(){
    this.plot_config.qs_plot.reset_scale();
    this.plot_config.tc_plot.reset_scale();
}
DrawMainView.prototype.layout = function(data, selected_items=[], 
                selected_relation=[], selected_concepts=[], 
                color_mode="1", projection_mode="1", current_inspected=0, 
                hover_data=-1, mode="") {
    /**
     * 0: "raw_question"
        1: "question_concept" // Used
        2: "model_result"
        3: "ground_truth" // Used
        4: "is_correct" // Used
        5: "conceptnet_concepts"
        6: "shap_concepts"
        7: "shap_concept_positions"
        8: "overlap_concepts"
        9: "question_concept_correct_answer_relations" // Used
        10: "qc_2d_x"
        11: "qc_2d_y"
        12: "qs_2d_x" // Used
        13: "qs_2d_y" // Used
        14: "tc_2d_x" // Used
        15: "tc_2d_y" // Used
     */
    /**
     * Other Relations
     * DerivedFrom: 1
        FormOf: 1
        NotHasProperty: 1
        createdby: 2
        isa: 8
        notdesires: 7
        receivesaction: 1
     */
    let other_relations = ["DerivedFrom", "FormOf", "NotHasProperty", 
                        "createdby", "isa", "notdesires", "receivesaction"]
    data = replace_relations_as_others(data, other_relations);
    console.log("layout data", data, selected_items, selected_relation, selected_concepts);

    let selected_keys = selected_concepts.map((d)=>""+d.index);
    let main_keys = Object.keys(data);
    let selected_mapping = construct_index_mapping(main_keys, selected_keys);
    let topk_relation = -1;
    console.log("selected mapping", selected_mapping);
    var relation_info_results = process_relation_info(data, topk_relation, selected_relation);
    var relation_info_list = relation_info_results["relation_info_list"];
    var relation_mapping_to_index = relation_info_results["relation_mapping_to_index"];
    this.update_color_items(getColorItems(color_mode, relation_mapping_to_index));
    var qs_scatter_plot = this.plot_config["qs_plot"]
    var tc_scatter_plot = this.plot_config["tc_plot"]
    var relation_plot = this.plot_config["relation_plot"]
    var selected_relation_index = {}
    var color_index = {}
    data.forEach((d, index)=>{
        selected_relation_index[index] = judge_selected_by_relation(d, selected_relation);
        
        color_index[index] = getItemColor(d, color_mode, relation_mapping_to_index, selected_relation);
    })

    var qs_data = data.map((d, index)=>{
        let coords = getCoordinatesbyProjectionMode("qs", projection_mode, d)
        let info = getInfo(d);
        return {
            "concept":"qs",
            "info": info,
            "x": coords.x,
            "y": coords.y,
            "color": color_index[index],
            "index": index,
            "selected": selected_mapping[index],
            "highlighted": index == current_inspected,
            "hovered": index == hover_data,
            "selected_by_relation": selected_relation_index[index] 
        }
    })
    //.filter(d=>{
    //    return d["selected_by_relation"];
    //})
    var tc_data = data.map((d, index)=>{
        let coords = getCoordinatesbyProjectionMode("tc", projection_mode, d)
        let info = getInfo(d);
        return {
            "concept":"tc",
            "info": info,
            "x": coords.x,
            "y": coords.y,
            "color": color_index[index],
            "index": index,
            "selected": selected_mapping[index],
            "highlighted": index == current_inspected,
            "hovered": index == hover_data,
            "selected_by_relation": selected_relation_index[index] 
        }
    })
    //.filter(d=>{
    //    return d["selected_by_relation"];
    //})

    var selected_data = qs_data.filter(d=>{
        if(d.selected && d.selected_by_relation){
            return true;
        }else{
            return false;
        }
    })
    if(compareTwoListofItems(selected_items, selected_data)){
        qs_scatter_plot.layout(qs_data, "Question", mode);
        tc_scatter_plot.layout(tc_data, "Answer", mode);
        relation_plot.layout(relation_info_list, "Relation");
    }else{
        console.log("Different update again");
        pipeService.emitSelectData(selected_data);
    }

    
}

export default DrawMainView